import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <>
    <Helmet>
      <title>Seite nicht gefunden – Schlüsseldienst.services</title>
    </Helmet>
    <div className="container mx-auto px-4 py-24 text-center">
      <h1 className="text-6xl font-bold text-orange-600 mb-4">404</h1>
      <h2 className="text-3xl font-bold mb-6">Seite nicht gefunden</h2>
      <p className="text-lg text-gray-600 mb-8">
        Die gesuchte Seite existiert leider nicht. Möglicherweise wurde sie verschoben oder gelöscht.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link 
          to="/schluesseldienst-dortmund" 
          className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-full font-bold"
        >
          Zur Startseite
        </Link>
        <Link 
          to="/einsatzgebiete" 
          className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-3 rounded-full font-bold"
        >
          Einsatzgebiete
        </Link>
      </div>
    </div>
  </>
);

export default NotFoundPage;
